import React from 'react';
import { connect } from 'react-redux';

import { CheckboxFieldWithoutForm } from 'src/components';
import { getSelectOptions } from 'src/reducers/selectOptions';
import MemoList from 'src/features/Memos';
import { getOptionLabel, getGroupFullPathName } from 'src/utils/Utils';
import { formatDate } from 'src/utils/Date';

import styles from './EmployeeTable.scss';

const EmployeeTableRow = props => {
  const { checked, employee, clientEmploymentTypes, groups, positions, onClickRow, onClickCheckbox } = props;
  const isChecked = checked ? 'm-table-checkbox-on' : 'm-table-checkbox-off';
  const className = checked ? styles.abled : styles.disabled;

  return (
    <tr onClick={onClickRow} className={`${className} table-hover`}>
      <td
        onClick={e => {
          e.stopPropagation();
          onClickCheckbox(employee.id);
        }}
        role="presentation"
        className={isChecked}
      >
        <CheckboxFieldWithoutForm
          checked={checked}
          onChange={() => {
            onClickCheckbox(employee.id);
          }}
          disabled={!employee.staffCode}
        />
      </td>
      <td>
        <MemoList employeeId={employee.id} />
      </td>
      <td>{employee.staffCode}</td>
      <td>{employee.fullName}</td>
      <td>{getOptionLabel(employee.employmentTypeId)(clientEmploymentTypes)}</td>
      <td>{!!employee.groupId && <div>{getGroupFullPathName(groups, employee.groupId)}</div>}</td>
      <td>{getOptionLabel(employee.positionId)(positions)}</td>
      <td>{formatDate(employee.joinedOn)}</td>
    </tr>
  );
};

export default connect(state => ({
  clientEmploymentTypes: getSelectOptions(state, 'connectedEmploymentTypes'),
  groups: getSelectOptions(state, 'flattenGroups'),
  positions: getSelectOptions(state, 'positions')
}))(EmployeeTableRow);
